/* @flow */

/**
 * Convert location format from DMM to DD.
 * @param {string} dmmStr DMM format in string, ex: N22 39.412 E121 28.323
 */
export function dmmToDd(dmmStr: string): object {
  const dmms = dmmStr.split(' ')
  const latD = (dmms[0][0] === 'S' ? -1 : 1) * parseInt(dmms[0].slice(1), 10)
  const latd  = parseFloat((parseFloat(dmms[1]) / 60).toFixed(3))
  const lngD = (dmms[2][0] === 'W' ? -1 : 1) * parseInt(dmms[2].slice(1), 10)
  const lngd = parseFloat((parseFloat(dmms[3]) / 60).toFixed(3))
  
  return { lat: latD + latd, lng: lngD + lngd }
}

export function emailToKey(email: string): string {
  return email.replace(/\./g, '_')
}

export function encryptCreditCard(cardNo: string): string {
  return cardNo.replace(/(^[\d]{4})([\d]{4})([\d]{4})([\d]{4})/,
    (match, p1, p2, p3, p4) => [p1, '****', '****', p4].join('-'))
}

export function getObjectByStringPath(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
          o = o[k];
      } else {
          return;
      }
  }
  return o;
}


// WEBPACK FOOTER //
// ./src/libs/utility.js